import CheckoutSectionView from 'chairisher/view/checkout/checkoutsection';

/**
 * Maps to 'data' html attributes that store the submit button's text.
 */
const submitButtonDataAttributes = Object.freeze({
    DEFAULT_TEXT: 'default-text',
    LOADING_TEXT: 'loading-text',
});

/**
 * View for controlling the final section in checkout - user confirms and submits purchase.
 */
class CheckoutConfirmView extends CheckoutSectionView {
    constructor(selector) {
        super(selector);
        this.$submitButton = this.$el.find('.js-btn-submit');
        this.$paymentRequestButtonWrapper = this.$el.find('.js-payment-request-button-wrapper');
    }

    /**
     * @returns {jQuery}
     */
    getSubmitButton() {
        return this.$submitButton;
    }

    /**
     * @returns {jQuery}
     */
    getPaymentRequestButtonWrapper() {
        return this.$paymentRequestButtonWrapper;
    }

    /**
     *
     * @param {boolean} shouldDisable
     */
    toggleSubmitButtonDisabled(shouldDisable) {
        this.$submitButton.prop('disabled', shouldDisable);
    }

    /**
     * Disables the submit button and replaces its text with something like 'Loading...'.
     * Callers should restore the previous text after the loading is complete.
     */
    setSubmitButtonLoading() {
        this.toggleSubmitButtonDisabled(true);
        this.setSubmitButtonText(this.$submitButton.data(submitButtonDataAttributes.LOADING_TEXT));
    }

    setDefaultSubmitButtonText() {
        this.setSubmitButtonText(this.$submitButton.data(submitButtonDataAttributes.DEFAULT_TEXT));
    }

    /**
     * Hides the normal 'submit' button and shows the payment request (e.g. Apple / Google) submit button.
     */
    setPaymentRequestButton() {
        this.$submitButton.addClass('hidden');
        this.$paymentRequestButtonWrapper.removeClass('hidden');
    }

    /**
     * @returns {string}
     */
    getCurrentSubmitButtonText() {
        return this.$submitButton.text();
    }

    /**
     * Hides the payment request button, and shows the submit button, with the given text.
     *
     * @param {string} text
     */
    setSubmitButtonText(text) {
        this.$paymentRequestButtonWrapper.addClass('hidden');
        this.$submitButton.removeClass('hidden');
        this.$submitButton.text(text);
    }
}

export default CheckoutConfirmView;
